export function buildMetricsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Metrics.Queries.MetricsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}



export function buildResourceMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.Metrics.Queries.ResourceMetricConfigurationQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'MetricId': metricId
	}
}

export function buildRevenueMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.Metrics.Queries.RevenueMetricConfigurationQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'MetricId': metricId
	}
}


export function buildTotalCostMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.Metrics.Queries.TotalCostMetricConfigurationQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'MetricId': metricId
	}
}

export function buildCapexMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.Metrics.Queries.CapexMetricConfigurationQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'MetricId': metricId
	}
}

export function buildResourceCostMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		$type: 'TCh.Domain.Quest.Metrics.Queries.ResourceCostMetricConfigurationQueryV1, TCh.Domain.Quest',
		WorkspaceId: workspaceId,
		StrategyId: strategyId,
		MetricId: metricId,
	};
}

export function buildMarginCogsMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		$type: 'TCh.Domain.Quest.Metrics.Queries.MarginCogsMetricConfigurationQueryV1, TCh.Domain.Quest',
		WorkspaceId: workspaceId,
		StrategyId: strategyId,
		MetricId: metricId,
	};
}

export function buildExpenseMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		$type: 'TCh.Domain.Quest.Metrics.Queries.ExpenseMetricConfigurationQueryV1, TCh.Domain.Quest',
		WorkspaceId: workspaceId,
		StrategyId: strategyId,
		MetricId: metricId,
	};
}

export function buildCostSubtotalMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
{
	return {
		$type: 'TCh.Domain.Quest.Metrics.Queries.CostSubtotalMetricConfigurationQueryV1, TCh.Domain.Quest',
		WorkspaceId: workspaceId,
		StrategyId: strategyId,
		MetricId: metricId,
	};
}

